import React from "react";

function KeenToSeeMoreModal({ isOpen, onClose, onConfirm, roleName, loading }) {
  if (!isOpen) {
    return null;
  }

  const handleBackdropClick = (e) => {
    // Only close if the click is directly on the backdrop, not on any child elements
    if (e.target === e.currentTarget) {
      onClose();
    }
  };

  const handleModalContentClick = (e) => {
    // Prevent any click events from bubbling up to the backdrop
    e.stopPropagation();
  };

  return (
    <div
      className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50"
      onClick={handleBackdropClick}
      onMouseDown={(e) => {
        // Prevent mousedown events from closing the modal when selecting text
        if (e.target !== e.currentTarget) {
          e.stopPropagation();
        }
      }}
    >
      <div
        className="bg-white rounded-lg shadow-lg p-6 md:p-8 w-full max-w-md mx-4"
        onClick={handleModalContentClick}
        onMouseDown={handleModalContentClick}
        onMouseUp={handleModalContentClick}
      >
        <div className="flex items-start">
          <div className="flex-shrink-0">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              viewBox="0 0 24 24"
              strokeWidth="1.5"
              stroke="currentColor"
              className="w-8 h-8 text-[#02B491]"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                d="M18 7.5v3m0 0v3m0-3h3m-3 0h-3m-2.25-4.125a3.375 3.375 0 1 1-6.75 0 3.375 3.375 0 0 1 6.75 0ZM3 19.235v-.11a6.375 6.375 0 0 1 12.75 0v.109A12.318 12.318 0 0 1 9.374 21c-2.331 0-4.512-.645-6.374-1.766Z"
              />
            </svg>
          </div>
          <div className="ml-4">
            <h2 className="text-xl font-semibold">Keen to see more candidates?</h2>
          </div>
        </div>
        <p className="mt-4 text-gray-700">
          You've cleared all candidates from your <span className="font-bold">{roleName}</span> shortlist. Would you like our team to find more qualified candidates for this role?
        </p>
        <div className="mt-6 flex justify-end space-x-4">
          <button
            onClick={onClose}
            className="px-6 py-2 text-sm font-medium text-gray-700 bg-gray-200 rounded-md hover:bg-gray-300 transition"
          >
            No, thanks
          </button>
          <button
            onClick={onConfirm}
            disabled={loading}
            className="px-6 py-2 text-sm font-medium text-white bg-[#02B491] rounded-md hover:bg-[#029d7a] transition disabled:opacity-50 disabled:cursor-not-allowed"
          >
            {loading ? "Sending..." : "Yes, email me more candidates"}
          </button>
        </div>
      </div>
    </div>
  );
}

export default KeenToSeeMoreModal; 